import { Component, Inject, inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SelectButtonChangeEvent, SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import Keycloak from 'keycloak-js';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutUtilsService } from 'src/app/services/layout-utils.service';
import { PermissionDirective } from 'src/app/shared/directives/permission.directive';

@Component({
  selector: 'rqa-right-navbar',
  templateUrl: './right-navbar.component.html',
  styleUrls: ['./right-navbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SelectButtonModule,
    RouterModule,
    TooltipModule,
    TranslateModule,
    PermissionDirective
  ]
})
export class RightNavbarComponent {
  constructor(@Inject(DOCUMENT) private document: Document) {
    const savedTheme = localStorage.getItem('app-theme');
    this.isDarkMode = savedTheme === 'dark';
    this.applyTheme();
  }
  private keycloak = inject(Keycloak);
  private layoutUtilsService = inject(LayoutUtilsService);
  selectedTheme: string = 'lara-light-indigo';
  themeOptions = [
    { label: 'Light', value: 'lara-light-indigo' },
    { label: 'Dark', value: 'lara-dark-indigo' }
  ];
  isDarkMode: boolean = false;

  switchTheme(theme: SelectButtonChangeEvent) {
    const themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if (themeLink && theme.value) {
      themeLink.href = theme.value + '.css';
    }
  }
  logout() {
    this.keycloak.logout({ redirectUri: window.location.origin });
  }

  openNotes() {
    this.layoutUtilsService.notesVisible.set(true);
  }

  toggleDarkMode() {
    this.isDarkMode = !this.isDarkMode;
    this.applyTheme();
    localStorage.setItem('app-theme', this.isDarkMode ? 'dark' : 'light');
  }

  private applyTheme() {
    const htmlElement = this.document.documentElement;
    if (this.isDarkMode) {
      htmlElement.classList.add('app-dark');
    } else {
      htmlElement.classList.remove('app-dark');
    }
  }
}
